import { ISynchronizationRequest } from '@domain/interfaces/hooks/IStoreSynchronization';
import {
  ESynchronizationRequestType,
  ESynchronizationType,
} from '@domain/enums/hooks/ESynchronization';

import { LONG_API_DOMAIN } from '@constants/api';

import { getEnvironment } from '@helpers/utils/environment';

export const getPerfectPaySynchronizationRequestConfig = (
  type: ESynchronizationType,
  storeAliasId: string | undefined,
  params: string,
): ISynchronizationRequest => {
  if (type === ESynchronizationType.STORE_ORDER) {
    return {
      type: ESynchronizationRequestType.POST,
      domain: LONG_API_DOMAIN,
      api: `/${getEnvironment()}/api/v1/users/stores/${storeAliasId}/perfect-pay/orders/sync`,
      requestParams: params,
    };
  }

  return {} as ISynchronizationRequest;
};
